module.exports = __webpack_public_path__ + "static/img/wqx.ec3b9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wqx.png
// module id = XFOy
// module chunks = 1